import React, { Component } from "react";
import { DataTable } from '@learningblocks/shared-components';
import { cloneDeep } from "lodash";
import "./style.scss";

export class RecordAbsorbance extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  doneClicked =()=>{
    this.props.absorbanceTable.data.forEach((row, rowIndex) => {
      row.forEach((cell, cellIndex) => {
        if(cell.hasOwnProperty('linkedField')){
          this.props.questionTableCellUpdateResults({
            id: (cell.linkedField.rowId - 1) + "_" + (cell.linkedField.cellId - 1),
            value: cell.value
          })
        }
      })
    })

    this.props.showModal({
      display: false
    })
  }

  tableData = {
    "indices": [10, 2],
    "data": [
      [
        {"type": "TITLE", "text": "pH standards"},
        {"type": "TITLE", "text": "Abs (615mm)"}
      ],
      [
        {"type": "FIXED", "text": "6.1"},
        {"type": "FIXED", "text": "0.12"}
      ],
      [
        {"type": "FIXED", "text": "6.3"},
        {"type": "FIXED", "text": "0.24"}
      ],
      [
        {"type": "FIXED", "text": "6.5"},
        {"type": "FIXED", "text": "0.26"}
      ],
      [
        {"type": "FIXED", "text": "6.7"},
        {"type": "FIXED", "text": "0.42"}
      ],
      [
        {"type": "FIXED", "text": "6.9"},
        {"type": "FIXED", "text": "0.46"}
      ],
      [
        {"type": "FIXED", "text": "7.1"},
        {"type": "FIXED", "text": "0.62"}
      ],
      [
        {"type": "FIXED", "text": "7.3"},
        {"type": "FIXED", "text": "0.68"}
      ],
      [
        {"type": "FIXED", "text": "7.5"},
        {"type": "FIXED", "text": "0.85"}
      ],
      [
        {"type": "FIXED", "text": "7.7"},
        {"type": "FIXED", "text": "0.91"}
      ]
    ]
  }

  dimensions = {
    width: 450,
    height: 300,
    margin: { top: 30, right: 0, bottom: 30, left: 60 }
  };

  convertField = (field) => {
    return (field.type === "input" || isNaN(parseFloat(field.text, 10)))?field.value:field.text;
  }

  convertData = (data) => {
    let newData = cloneDeep(data);
    newData.shift();
    return newData.map((row, index)=>{
        return {
          x: this.convertField(row[0]),
          y: this.convertField(row[1])
        }
    })
  }

  render() {

    return (
      <div className="modal-section record-absorbance" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <h2>Absorbance of samples</h2>
        </div>
        <div className="modal-body">
          <div className="modal-inner">
            <div>
              <DataTable
                className={'questionTable__tableWrapper'}
                indices={this.props.absorbanceTable.indices}
                data={this.props.absorbanceTable.data}
                onCellChange={(e)=>{
                  this.props.absorbanceTableCellUpdate(e)
                }}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={this.doneClicked}>
              Done
          </button>
        </div>
      </div>
    );
  }
}
